
import { defineComponent, nextTick, onBeforeMount, onMounted, watch } from 'vue'
import KTContent from '@/components/layout/Content.vue'
import LayoutService from '@/services/LayoutService'
import { reinitializeComponents } from '@/assets/metronik/ts/keenthemes'
import { useRoute } from 'vue-router'
import { useConnectAs } from '@/composables/useConnectAs'

export default defineComponent({
  name: 'MainLayout',
  components: {
    KTContent
  },
  setup () {
    const route = useRoute()
    const { isConnectedAs } = useConnectAs()

    onBeforeMount(() => {
      LayoutService.init()
    })

    onMounted(() => {
      nextTick(() => {
        reinitializeComponents()
      })
    })

    watch(
      () => route.path,
      () => {
        nextTick(() => {
          reinitializeComponents()
        })
      }
    )

    return { isConnectedAs }
  }
})
